import React from 'react';
import { useAppType } from '../../../../../hooks/useAppType';
import { ConsumerAppAccountLandingScreen } from '../../../../shared/Account/ConsumerAccountLandingScreen';
import UserAccountInformationScreen from '../../../../shared/Account/UserAccountInformationScreen';

export type AccountScreenOwnProps = {};

export type AccountScreenProps = AccountScreenOwnProps;

export const AccountScreen: React.FC<AccountScreenProps> = () => {
    const appType = useAppType();
    return appType === 'consumer' ? <ConsumerAppAccountLandingScreen /> : <UserAccountInformationScreen />;
};

export default React.memo(AccountScreen);
